import { AppAction } from '@om-fe/store';
export const TOP_BETS_TIME_RANGE_PATH: string = 'time-ranges-discipline/:disciplineId/:offsetTime';
export const TOP_BETS_TIME_RANGE_LOCATION_PATH= 'time-ranges-discipline-location/:disciplineId/:locationId/:offsetTime';
export const TOP_BETS_TIME_RANGE_CATEGORY_PATH= 'time-ranges-discipline-category/:disciplineId/:categoryId/:offsetTime';

export const slicePrefix = `Top-Bets-Time-Range`;

export enum TopBetsTimeRangeActions {
    SetLoadingData = 'sports:top-bets-time-range:set-loading-data',
    SetFilterData = 'sports:top-bets:set-top-bets-time-range-filter-data',
}

export interface TopBetsTimeRangeSetLoadingData extends AppAction<TopBetsTimeRangeActions.SetLoadingData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly isLoadingData: boolean;
    };
}

export interface TopBetsTimeRangeSetFilterDataAction extends AppAction<TopBetsTimeRangeActions.SetFilterData> {
    readonly meta: {
        readonly slice: string;
    };
    readonly payload: {
        readonly disciplineId: string;
        readonly locationId?: string;
        readonly categoryId?: string;
    };
}

export interface TopBetsTimeRangeTopic {
    readonly path: string;
    readonly params: {
        readonly disciplineId: string;
        readonly offsetTime: number;
        readonly locationId?: string;
        readonly categoryId?: string;
    };
}


export interface TopBetsTimeRangeStoreModel {
    readonly ready: boolean;
    readonly isLoadingMoreData: boolean;
    readonly isLoadingData: boolean;
    readonly disciplineId?: string;
    readonly locationId?: string;
    readonly isDefault?: boolean;
    readonly mainMarketsLimit?: number;
    readonly limit: number;
    readonly totalRecords: number;
    readonly eventCategoryId?: string;
    readonly marketGroupsOverviewNumber?: number;
    readonly marketGroupsOverviewIds?: string;
}